export const ACTIVE = 'active'
export const TERMINATED = 'terminated'
